import React, { useEffect, useRef, useState } from "react";
import "./CultureInnovation.css";

const CultureInnovation = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Déclenche l’animation une seule fois
        }
      },
      { threshold: 0.3 } // Déclenche quand 30% de la section est visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <div
      className={`culture-container ${isVisible ? "animate-fade-up" : ""}`}
      ref={sectionRef}
    >
      <div className="culture-header">
        <h2 className="cultureinnovation-title">
          <span className="corner top-left" />
          <span className="corner top-right" />
          Nos Cultures d’Innovation et d’Employabilité dans le Monde
          <span className="corner bottom-left" />
          <span className="corner bottom-right" />
        </h2>
      </div>

      <div className="description-box">
        <p className="description">
          Découvrez comment l'innovation et la montée en compétences
          transforment les économies et les métiers à travers le monde. Nous
          suivons pour vous les initiatives les plus inspirantes pour bâtir un
          avenir durable et inclusif.
        </p>
      </div>

      <div className="cards-grid">
        <div className="card">
          <h3>Planifier sa carrière au Canada : par où commencer ?</h3>
          <p className="card-textdesc">
            La planification de carrière est une démarche essentielle pour bâtir
            un avenir professionnel solide.
            <br /> <br />
            Le Guichet-Emplois du gouvernement du Canada propose un parcours en
            cinq étapes pour mieux se connaître, explorer le marché du travail,
            choisir une formation adaptée, se démarquer auprès des employeurs et
            bâtir un réseau professionnel.
            <br /> <br />
            Ces ressources aident chacun à faire des choix éclairés pour
            atteindre ses objectifs.
          </p>
          <button
            className="read-more"
            onClick={() =>
              window.open(
                "https://www.guichetemplois.gc.ca/planification-carriere/ressources"
              )
            }
          >
            Regarder la suite <span>&rarr;</span>
          </button>
        </div>

        <div className="card">
          <h3>Explorer le marché du travail au Canada</h3>
          <p className="card-textdesc">
            Les centres d’emploi, répartis à travers le pays, offrent un
            accompagnement personnalisé pour aider les chercheurs d’emploi à
            atteindre leurs objectifs professionnels.
            <br />
            <br />
            Grâce à l’outil de recherche du Guichet-Emplois, vous pouvez
            localiser facilement le centre le plus proche en saisissant votre
            ville ou code postal. Ces centres proposent des services tels que
            l’aide à la rédaction de CV, la préparation aux entretiens et des
            conseils sur le marché du travail.
          </p>
          <button
            className="read-more"
            onClick={() => window.open("https://www.guichetemplois.gc.ca")}
          >
            Regarder la suite <span>&rarr;</span>
          </button>
        </div>

        <div className="card">
          <h3>Trouver un centre de carrière aux USA </h3>
          <p className="card-textdesc">
            Les centres d'emploi américains (AJC) sont situés partout aux
            États-Unis et offrent des services gratuits pour aider les
            particuliers à rechercher un emploi, à trouver une formation et à
            répondre aux questions liées à l'emploi.
            <br />
            <br />
            Les services comprennent des salles de ressources avec téléphones,
            Internet gratuit, des outils de rédaction de CV, l'élaboration de
            plans d'emploi et une formation professionnelle.
          </p>
          <button
            className="read-more"
            onClick={() =>
              window.open(
                "https://www.bls.gov/ooh/business-and-financial/home.htm"
              )
            }
          >
            Regarder la suite <span>&rarr;</span>
          </button>
        </div>

        {/* <div className="card">
          <h3>Explorer le marché du travail au Canada</h3>
          <p className="card-textdesc">
            Les centres d’emploi, répartis à travers le pays, offrent un
            accompagnement personnalisé pour aider les chercheurs d’emploi à
            atteindre leurs objectifs professionnels.
            <br />
            <br />
            Grâce à l’outil de recherche du Guichet-Emplois, vous pouvez
            localiser facilement le centre le plus proche en saisissant votre
            ville ou code postal. Ces centres proposent des services tels que
            l’aide à la rédaction de CV, la préparation aux entretiens et des
            conseils sur le marché du travail.
          </p>
          <button
            className="read-more"
            onClick={() => window.open("https://www.bls.gov/ooh/", "_blank")}
          >
            Regarder la suite <span>&rarr;</span>
          </button>
        </div>

        <div className="card">
          <h3>Find a Career Center in USA</h3>
          <p className="card-textdesc">
            American Job Centers (AJCs) are located across the United States,
            offering free services to help individuals search for jobs, find
            training, and answer employment-related questions. <br />
            <br />
            Services include resource rooms with phones, free internet, resume
            writing tools, employment plan development, and job training.
          </p>
          <button
            className="read-more"
            onClick={() => window.open("https://www.bls.gov/ooh/", "_blank")}
          >
            Regarder la suite <span>&rarr;</span>
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default CultureInnovation;
